class CandidateJobApplicationReq {
    constructor() {
      this.jobApplicationId = null;
      this.candidateId = null;
      this.userId = null;
      this.scheduleLink = null;
    }
};

export default CandidateJobApplicationReq;